import React from 'react';
import { AiFillHome } from 'react-icons/ai'; // Home icon
import { MdChevronRight } from 'react-icons/md'; // Chevron icon

const Breadcrumb = (props) => {
  const { breadcrumbs, title, paragraph } = props;

  return (
    <div className="bg-background-back1 py-28 px-4">
      <div className="container max-w-[78rem] mx-auto rounded-xl blurBox h-auto w-full p-6 flex flex-col gap-5 relative">
        <div className="mobileHide">
          <nav aria-label="breadcrumb">
            <ol className="flex flex-wrap items-center gap-1.5 break-words text-sm sm:gap-2.5 text-white">
              <li className="inline-flex items-center gap-1.5 lg:text-sm xl:text-sm 2xl:text-sm text-xs capitalize">
                <a href="/">
                  <AiFillHome className="h-[17px] w-[17px]" />
                </a>
              </li>
              {breadcrumbs.map((breadcrumb, index) => (
                <React.Fragment key={index}>
                  {index > 0 && (
                    <li
                      role="presentation"
                      aria-hidden="true"
                      className="[&>svg]:size-3.5"
                    >
                      <MdChevronRight />
                    </li>
                  )}
                  <li className="inline-flex items-center gap-1.5 lg:text-sm xl:text-sm 2xl:text-sm text-xs capitalize">
                    {breadcrumb.link ? (
                      <a href={breadcrumb.link} className="font-normal text-muted-foreground">
                        {breadcrumb.label}
                      </a>
                    ) : (
                      <span
                        role="link"
                        aria-disabled="true"
                        aria-current="page"
                        className="font-normal text-muted-foreground"
                      >
                        {breadcrumb.label}
                      </span>
                    )}
                  </li>
                </React.Fragment>
              ))}
            </ol>
          </nav>
        </div>
        <div>
          <div className="absolute inset-0"></div>
          {/* <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold inline  bg-[linear-gradient(45deg,_#00bf67,_#0068ff)] bg-clip-text text-transparent">
            {title}
          </h1> */}
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold inline">
  <span className="text-black">
    {(title || '').match(/^([\p{Emoji_Presentation}\p{Extended_Pictographic}]+)/gu)?.[0] || ''}
  </span>
  <span className="bg-[linear-gradient(45deg,_#00bf67,_#0068ff)] bg-clip-text text-transparent">
    {(title || '').replace(/^([\p{Emoji_Presentation}\p{Extended_Pictographic}]+)/gu, '')}
  </span>
</h1>
          <h2 className="mt-2 md:mt-4 font-normal text-neutral-300 capitalize text-xs md:text-sm lg:text-lg">
            {paragraph}
          </h2>
        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;
